import { ChallengeService } from '@duck/api-definitions'

export const getChallengeErrorCode = (axiosError: any): ChallengeService.ChallengeErrorCode | null => {
    if (axiosError.response?.data && 'errorCode' in axiosError.response.data) {
        return axiosError.response?.data.errorCode as ChallengeService.ChallengeErrorCode
    }
    return null
}